import {
  useAnnualRevenueDropdownQuery,
  useBankDropdownQuery,
  useBusinessTypeDropdownQuery,
  useBusinessYearDropdownQuery,
  useCityDropdownQuery,
  useCompanySizeDropdownQuery,
  useCountryDropdownQuery,
  useMerchantCustomerDropdownQuery,
  usePaymentRepeatTypeDropdownQuery,
  usePaymentStatusDropdownQuery,
  usePaymentTypeDropdownQuery,
  useRecipientCategoryDropdownQuery,
  useRecipientListingQuery,
  useRejectReasonDropdownQuery,
  useStateDropdownQuery,
  useUserCardDropdownQuery} from '@stack/data-access';

export type QueryRegistryProps = {
  name: string;
  hooks: any;
};
export const QueryRegistry: QueryRegistryProps[] = [
  {
    name: 'BankDropdown',
    hooks: useBankDropdownQuery,
  },
  {
    name: 'RecipientCategoryDropdown',
    hooks: useRecipientCategoryDropdownQuery,
  },
  {
    name: 'CountryDropdown',
    hooks: useCountryDropdownQuery,
  },
  {
    name: 'StateDropdown',
    hooks: useStateDropdownQuery,
  },
  {
    name: 'PaymentTypeDropdown',
    hooks: usePaymentTypeDropdownQuery,
  },
  {
    name: 'BusinessYearDropdown',
    hooks: useBusinessYearDropdownQuery,
  },
  {
    name: 'BusinessTypeDropdown',
    hooks: useBusinessTypeDropdownQuery,
  },
  {
    name: 'CityDropdown',
    hooks: useCityDropdownQuery,
  },
  {
    name: 'RecipientListing',
    hooks: useRecipientListingQuery,
  },
  {
    name: 'UserCardDropdown',
    hooks: useUserCardDropdownQuery,
  },
  {
    name: 'PaymentRepeatTypeDropdown',
    hooks: usePaymentRepeatTypeDropdownQuery,
  },
  {
    name: 'PaymentStatusDropdown',
    hooks: usePaymentStatusDropdownQuery,
  },
  {
    name: 'RejectReasonDropdown',
    hooks: useRejectReasonDropdownQuery,
  },
  {
    name: 'CompanySizeDropdown',
    hooks: useCompanySizeDropdownQuery,
  },
  {
    name: 'AnnualRevenueDropdown',
    hooks: useAnnualRevenueDropdownQuery,
  },
  {
    name: 'MerchantCustomerDropdown',
    hooks: useMerchantCustomerDropdownQuery,
  }
];
